var exports = {
  "buttonGroup": "buttonGroup-QU56S",
  "horizontal": "horizontal-QU56S",
  "floatRight": "floatRight-QU56S",
  "button": "button-QU56S",
  "circle": "circle-QU56S",
  "bordered": "bordered-QU56S",
  "inverted": "inverted-QU56S",
  "icon": "icon-QU56S",
  "disabled": "disabled-QU56S",
  "mini": "mini-QU56S",
  "tiny": "tiny-QU56S",
  "small": "small-QU56S",
  "large": "large-QU56S",
  "huge": "huge-QU56S",
  "giant": "giant-QU56S",
};

__webpack_require__.r(module.exports = exports);
